import SignatureSoundBankPage from './SignatureSoundBankPage';

export default SignatureSoundBankPage;
